import {
  Box,
  Table,
  TableContainer,
  Tooltip,
  Tabs,
  Tab,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, useAuth } from "../../sdk";
import { Tbody, Td, Th, Thead } from "./Styles";
import { Stack } from "@mui/system";

const Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const TabsHeader = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: white;
  height: 52px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto 20px auto;
`;

const StyledTab = styled(Tab)`
  min-height: 52px;
  font-weight: bold;
  font-size: 16px;
  text-transform: none;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
  border-left: 4px solid transparent;
  color: #727272;

  &.Mui-selected {
    color: #322277;
    border-left: 4px solid #322277;
    border-bottom: none;
    background-color: rgba(48, 81, 221, 0.05);
  }

  &:hover {
    background-color: rgba(48, 81, 221, 0.08);
  }
`;

export default function FileUploads() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { authFetch,permission } = useAuth();
  const { hotelId } = useParams();
  const [data, setData] = React.useState([]);
  const [tab, setTab] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [deleteMode, setDeleteMode] = React.useState(false);
  const [selectedIds, setSelectedIds] = React.useState([]);
  let hasAccess;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  for (let key in permission) {
    if (permission.hasOwnProperty(key)) {
      if (permission[key].name === "deleteFileUploadsLogs") {
        hasAccess = true;
      }
    }
  }

  async function getUploads() {
    setLoading(true);
    const isParsed = tab === 0 ? true : false;
    const { post } = await authFetch({
      path: `/hotel/${hotelId}/uploaded-files?page=${
        page + 1
      }&limit=${rowsPerPage}&is_parsed=${isParsed}`,
    });

    const { data, error } = await post();
    if (data) {
      const sorted_data = data.sort(function (a, b) {
        return new Date(b.uploaded_date) - new Date(a.uploaded_date);
      });
      setData(sorted_data);
    } else {
      setData([]);
      console.log(error);
    }
    setLoading(false);
  }

  function formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    if (parseInt(hours) <= 9) {
      hours = "0" + hours;
    }
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime.toUpperCase();
  }

  useEffect(() => {
    getUploads();
    // eslint-disable-next-line
  }, [page, rowsPerPage, tab]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setPage(0);
  };

  const handleDeleteMode = () => {
    setDeleteMode((prev) => !prev);
    if (deleteMode) {
      setSelectedIds([]);
    }
  };

  const deleteAllLogs = async () => {
    setLoading(true);
    try {
      const { del } = await authFetch({
        path: `/hotel/${hotelId}/uploaded-files?ids=${selectedIds.join(",")}`,
      });
      const { response } = await del();
      if (response.status === 200) {
        setSelectedIds([]);
        getUploads();
      }
    } catch (error) {
      console.error("Failed to delete logs:", error);
      // Consider showing an error message to the user here.
    } finally {
      setDeleteMode(false);
      setLoading(false);
    }
  };
  return (
    <div>
      <TabsHeader>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            minHeight: 52,
            "& .MuiTabs-flexContainer": {
              gap: "24px",
            },
          }}
        >
          <StyledTab label="Successful Upload" />
          <StyledTab label="Failed Upload" />
        </Tabs>
      </TabsHeader>

      <Paper elevation={0} sx={{ paddingLeft: "25px", paddingRight: "25px" }}>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          padding={2}
        >
          {selectedIds.length > 0 && deleteMode && (
            <Button
              variant="contained"
              sx={{ textTransform: "none", marginBottom: 2 }}
              onClick={() => deleteAllLogs()}
            >
              Delete Selected
            </Button>
          )}
          {tab === 1 && hasAccess && (
            <Button
              variant="contained"
              sx={{ textTransform: "none", marginBottom: 2 }}
              onClick={handleDeleteMode}
            >
              {deleteMode ? "Cancel" : "Delete Logs"}
            </Button>
          )}
        </Stack>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="300px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Table>
              <Thead>
                <Row style={{ height: "40px" }}>
                  {deleteMode && <Th sx={{ width: "120px" }}></Th>}

                  <Th>Date</Th>
                  <Th>Upload Time</Th>
                  <Th>Type of File</Th>
                  <Th>Name</Th>
                  <Th>Uploaded File Source</Th>
                  <Th>Uploaded By</Th>
                  <Th>Download File</Th>
                </Row>
              </Thead>
              <Tbody />
            </Table>
            <TableContainer sx={{ maxHeight: 780, minWidth: 500 }}>
              <Table stickyHeader style={{ position: "relative" }}>
                <Thead />
                {data.length !== 0 &&
                  data?.map((row, index) => {
                    return (
                      <Tbody key={row.fileName}>
                        <Row
                          style={
                            index % 2 === 0
                              ? {
                                  backgroundColor: "rgba(48, 81, 221,0.09)",
                                  height: "52px",
                                }
                              : { height: "52px" }
                          }
                        >
                          {deleteMode && (
                            <Td
                              sx={{
                                borderBottom: "none",
                                width: "fit-content",
                              }}
                            >
                              <Checkbox
                                checked={selectedIds.includes(row.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedIds((prev) => [...prev, row.id]);
                                  } else {
                                    setSelectedIds((prev) =>
                                      prev.filter((id) => id !== row.id)
                                    );
                                  }
                                }}
                                size="small"
                              />
                            </Td>
                          )}
                          <Td sx={{ borderBottom: "none" }}>
                            <Box marginRight={2}>
                              {new Date(row.uploaded_date).toLocaleDateString(
                                "en-GB"
                              )}
                            </Box>
                            {Days[new Date(row.uploaded_date).getDay()]}
                          </Td>

                          <Td
                            sx={{
                              borderBottom: "none",
                            }}
                          >
                            {formatAMPM(new Date(row.uploaded_date))}
                          </Td>

                          <Td sx={{ borderBottom: "none" }}>{row.type}</Td>

                          <Tooltip title={row.fileName} arrow placement="top">
                            <Td
                              sx={{
                                borderBottom: "none",
                                cursor: "pointer",
                                textAlign: "justify",
                                wordBreak: "break-all",
                              }}
                            >
                              <Box
                                component={"p"}
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "160px",
                                }}
                              >
                                {row.fileName}
                              </Box>
                            </Td>
                          </Tooltip>

                          <Td
                            sx={{
                              borderBottom: "none",
                            }}
                          >
                            {row.isEmailUpload === false
                              ? "Via System"
                              : "Via E-mail"}
                          </Td>

                          <Tooltip title={row.senderEmail} arrow placement="top">
                            <Td
                              sx={{
                                borderBottom: "none",
                                textAlign: "justify",
                                wordBreak: "break-all",
                              }}
                            >
                              <Box
                                component={"p"}
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "160px",
                                }}
                              >
                                {row.senderEmail}
                              </Box>
                            </Td>
                          </Tooltip>

                          <Td
                            sx={{
                              borderBottom: "none",
                            }}
                          >
                            <Button
                              sx={{
                                textTransform: "none",
                              }}
                              target="_blank"
                              href={row.url}
                            >
                              Download
                            </Button>
                          </Td>
                        </Row>
                      </Tbody>
                    );
                  })}

                {data.length === 0 && (
                  <Tbody>
                    <Row
                      style={{
                        backgroundColor: "rgba(48, 81, 221,0.09)",
                      }}
                    >
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                      <Td sx={{ borderBottom: "none" }}>-</Td>
                    </Row>
                  </Tbody>
                )}
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={100}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to }) => null}
              nextIconButtonProps={{
                disabled: data.length < rowsPerPage,
              }}
            />
          </>
        )}
      </Paper>
    </div>
  );
}
